import React from 'react';
import PropTypes from 'prop-types';
import { a as addClassNames, c as classNamePropTypes } from './classNames-1ed461aa.js';
import { b as addMarginClasses, m as marginPropTypes } from './spacing-0f39ba4a.js';

/**
 * Used as basis of all Svg Icons
 */
function SvgIcon({
  children,
  size,
  className,
  margin,
  color,
  ...otherProps
}) {
  let cssClasses = ['st_icon', `st_icon--${size}`];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addMarginClasses(margin, cssClasses);
  if (color) cssClasses.push(`st_text--color-${color}`);
  const htmlProps = {
    xmlns: 'http://www.w3.org/2000/svg',
    className: cssClasses.join(' '),
    ...otherProps
  };
  return /*#__PURE__*/React.createElement("svg", htmlProps, children);
}
SvgIcon.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /**
   * the `<path>` for the SVG! Do not include the `<svg>` tag.
   * Pass any html/svg attributes as props to `<SvgIcon>` */
  children: PropTypes.any,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for icon, if any */
  margin: marginPropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white'])
};
SvgIcon.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null,
  children: null
};

export { SvgIcon as S };
